import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useJobDetails, ACTIONS } from "../../providers/jobDetailsProvider";
import { jobsApi } from "../../services/jobServices";
import Loader from "../../components/Loader";
import InPMContent from "../../components/admin/production/InPMContent";
import InProgressContent from "../../components/admin/production/InProgressContent";

const STATUS_IN_PROJECT_MANAGEMENT = 10;
const STATUS_IN_PROGRESS = 4;

const statusConfig = {
  [STATUS_IN_PROJECT_MANAGEMENT]: {
    tabId: "IN_PM_TAB",
    text: "Jobs In Project Management",
    component: InPMContent,
  },
  [STATUS_IN_PROGRESS]: {
    tabId: "IN_PROGRESS_TAB",
    text: "Jobs In Production",
    component: InProgressContent,
  },
};

const ProductionDetails = () => {
  const { id } = useParams();
  const [jobDetails, setJobDetails] = useJobDetails();
  const { job } = jobDetails;
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(null);
  const [textLink, setTextLink] = useState("");

  useEffect(() => {
    const fetchJob = async () => {
      setLoading(true);
      try {
        const jobData = await jobsApi.getJobsById(id);
        setJobDetails({
          action: ACTIONS.GET_JOB_SUCCESS,
          payload: { job: jobData },
        });

        const config = statusConfig[jobData.statusId];
        if (config) {
          setSelectedTab(config.tabId);
          setTextLink(config.text);
        } else {
          setSelectedTab(null);
          setTextLink("");
        }
      } catch (error) {
        console.error("Error fetching job details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJob();

    return () => {
      setJobDetails({
        action: ACTIONS.RESET,
      });
    };
  }, [id, setJobDetails]);

  if (loading || !job) {
    return (
      <Container fluid>
        <Header>
          <HeaderTitle className="text-dark">Production Scheduling</HeaderTitle>
        </Header>
        <Loader />
      </Container>
    );
  }

  return (
    <Container fluid>
      <Header>
        <HeaderTitle className="text-dark pb-3">
          Production Scheduling
        </HeaderTitle>
      </Header>
      <Row className="my-3">
        <Col>
          <h4 className="text-dark font-weight-bold">
            <Link
              to="/production"
              className="text-dark"
              state={{ tab: selectedTab }}
            >
              <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
              {textLink}
            </Link>
            <FontAwesomeIcon icon={faChevronRight} className="mx-2" />
            {job.jobNumber || id}
          </h4>
        </Col>
      </Row>
      {job &&
        statusConfig[job.statusId]?.component &&
        React.createElement(statusConfig[job.statusId].component)}
    </Container>
  );
};

export default ProductionDetails;
